import { render, staticRenderFns } from "./DrawControls.vue?vue&type=template&id=a5ba1ed8&scoped=true"
import script from "./DrawControls.vue?vue&type=script&lang=js"
export * from "./DrawControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ba1ed8",
  null
  
)

export default component.exports